import { ExternalLink, ExternalLinkReplacements, InternalLinkReplacements } from '@boxcryptor-web/ui';

function getPathAndUrl(to: string, baseUrl: string) {
  const url = new URL(to, baseUrl);
  const path = url.origin === baseUrl ? url.pathname : [url.origin, url.pathname].join('');
  const pathWithoutSlash = (path !== '/' ? path.replace(/\/+$/, '') : '/').toLowerCase();
  const pathWithSlash = (path.endsWith('/') ? path : `${path}/`).toLowerCase();
  return { pathWithoutSlash, pathWithSlash, url };
}

export const shouldRenderAsInternalLink: (options: { to: string; allInternalLinks: string[]; baseUrl: string }) => boolean = ({
  to,
  allInternalLinks,
  baseUrl,
}) => {
  const { pathWithoutSlash, pathWithSlash } = getPathAndUrl(to, baseUrl);
  return allInternalLinks.includes(pathWithoutSlash) || allInternalLinks.includes(pathWithSlash);
};

export const getReplacedInternalLink: (options: { to: string; replacements: InternalLinkReplacements; baseUrl: string }) => string = ({
  to,
  replacements,
  baseUrl,
}) => {
  const { pathWithoutSlash, pathWithSlash, url } = getPathAndUrl(to, baseUrl);
  const replacement = replacements[pathWithoutSlash] ?? replacements[pathWithSlash];
  if (!replacement) {
    return to;
  }
  return [replacement, url.search, url.hash].join('');
};

export const getReplacedExternalLink: (options: {
  link: ExternalLink;
  replacements: ExternalLinkReplacements;
  baseUrl: string;
}) => ExternalLink = ({ link, replacements, baseUrl }) => {
  const { pathWithoutSlash, pathWithSlash, url } = getPathAndUrl(link.href, baseUrl);
  const replacement = replacements[pathWithoutSlash] ?? replacements[pathWithSlash];
  if (!replacement) {
    return link;
  }
  return { ...replacement, href: [replacement.href, url.search, url.hash].join('') };
};
